(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name thismomentGlowModuleFooter
     * @module thismoment.glow.component.module.footer
     *
     * @description
     * The footer module for glow
     *
     * @example <pre><code>&#x3C;thismoment-glow-footer id=&#x22;1&#x22;&#x3E;&#x3C;/thismoment-glow-footer&#x3E;</code></pre>
     */

  require('./scss/module-footer.scss')

  var MODULE_NAME = 'thismoment.glow.component.module.footer'
  var templateUrl = require('./tpl/module-footer.html')

  angular
    .module(MODULE_NAME, [])
    .component('thismomentGlowModuleFooter', {
      templateUrl: templateUrl,
      bindings: {
        trackEvent: '&',
        moduleId: '<',
        name: '<',
        backgroundColor: '<',
        textLinkColor: '<',
        footerItems: '<',
        height: '<',
        textLinkAlignment: '<'
      },
      controller: glowFooterController
    })

    // glowFooterController.$inject = [''];
  function glowFooterController () {
    var vm = this

    vm.styles = vm.classes = {}

    vm.$onInit = footerInit

    function footerInit () {
      vm.styles = {
        wrapper: {
          'background-color': vm.backgroundColor,
          'color': vm.textLinkColor,
          'height': vm.height + 'px',
          'text-align': vm.textLinkAlignment
        }
      }
      vm.trackFooterClick = trackFooterClick
    }

    function trackFooterClick (route) {
      vm.trackEvent({
        action: 'Module Explored',
        properties: {
          'event trigger': 'clicked footer link',
          'event trigger detail': route
        }
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/glow/component/glow-module/module-footer/index.js